export default __webpack_public_path__ + "static/media/deep-fryer.811c0941.svg";